<div class="discount">

  <span class="sub_title">
    <fa-icon [icon]="getFaIcon('faTags')" appChangeColorTheme attribute="color"></fa-icon>
    Bons de réduction
  </span>

  <div class="edit_element">
    <fa-icon [icon]="getFaIcon('faPen')" [routerLink]="['/admin/discount']" [queryParams]="{clubCode: clubCode}"
      routerLinkActive="router-link-active" appChangeColorTheme attribute="color"> </fa-icon>
  </div>

  <div class="discount_content">
    <div class="discount_item">
      <p><span>{{discountsActive?.length}}</span> en cours</p>
    </div>

    <hr appChangeColorTheme attribute="bgc" attribute='0.5'>
    
    <div class="discount_item">
      <p><span>{{discounts?.length}}</span> bons </p>
    </div>
  </div>
</div>
